import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  },
  confirm: {
    actions: {
      false: "HAYIR",
      true: {
        text: "EVET",
        color: "primary"
      }
    },
    icon: false
  }
});

export default VuetifyDialog;
